import { useNavigate } from "react-router-dom";
import Page from "src/layouts/Page";
import GroupForm from "../../components/GroupForm/GroupForm";
import useCreateGroup from "../../hooks/useCreateGroup";
import { adaptGroupPayload } from "../../adapters/adaptGroupPayload";

const EMPTY_DEFAULTS: GroupFormValues = {
	name: "",
	description: ""
};

const CreateGroup = () => {
	const navigate = useNavigate();
	const { mutate: createGroup, isLoading } = useCreateGroup();

	const handleSubmit = (data: GroupFormValues) => {
		const payload = adaptGroupPayload(data);

		createGroup(payload, {
			onSuccess: () => navigate("/users/groups")
		});
	};

	return (
		<Page>
			<GroupForm
				defaultValues={EMPTY_DEFAULTS}
				onSubmit={handleSubmit}
				isSubmitting={isLoading}
				isEdit={false}
				backPath="/users/groups"
			/>
		</Page>
	);
};

export default CreateGroup;
